import { Box } from '@mui/material';
import { useState } from 'react';
import ExoDialog from '../../../components/exo/ExoDialog';
import { PhaseWrapper } from './PhaseWrapper';
import ProjectTimeCard from '../ProjectTimeCard';
import { useTimeTracking } from '../../../components/time-tracking/AppTimeProvider';
import { useConfig } from '../../../api/api';

export const ProjectList = ({ projects }) => {
  const [selectedProject, setSelectedProject] = useState(null);
  const { clockIn, activeProject } = useTimeTracking();
  const config = useConfig();
  const requireWorkPackage = Boolean(
    Number(config?.timesheet?.requireWorkPackageForTimeTracking)
  );

  function hasSelectableWorkPackages(project) {
    return project.phases.some((phase) =>
      phase.workPackages.some(
        (workPackage) =>
          (workPackage.status === 0 || workPackage.status === 2) &&
          (!requireWorkPackage || Boolean(workPackage.isTimeTrackable))
      )
    );
  }

  function handleProjectSelection(project) {
    if (hasSelectableWorkPackages(project)) {
      setSelectedProject(project);
    } else if (!requireWorkPackage) {
      clockIn(project);
    }
  }

  const shownProjects = requireWorkPackage
    ? projects.filter(hasSelectableWorkPackages)
    : projects;

  return (
    <Box
      className="flex justify-around sm:justify-start flex-wrap gap-2 h-full"
      sx={{
        overflowY: activeProject ? 'hidden' : 'auto',
        height: activeProject ? '600px' : 'auto',
      }}
    >
      {shownProjects.map((project) => (
        <ProjectTimeCard
          key={project.id}
          project={project}
          onClick={handleProjectSelection}
        />
      ))}
      <ExoDialog
        open={Boolean(selectedProject)}
        onClose={() => setSelectedProject(null)}
      >
        {selectedProject && (
          <Box className="h-full flex flex-col overflow-y-auto">
            <Box className="flex flex-col gap-5">
              {selectedProject.phases.map(
                (phase) =>
                  phase.workPackages.length > 0 && (
                    <PhaseWrapper
                      key={phase.id}
                      phase={phase}
                      project={selectedProject}
                      onDeselect={() => setSelectedProject(null)}
                    />
                  )
              )}
            </Box>
          </Box>
        )}
      </ExoDialog>
    </Box>
  );
};
